import api from '@/helpers/fetch'
import Vue from 'vue'

export default {
	state: {
		courtsList: null,
		courthousesList: null,
	},
	mutations: {
		ADD_COURTS(state, courts) {
			state.courtsList = courts
		},
		ADD_COURTHOUSES(state, courts) {
			state.courthousesList = courts
		},
	},
	actions: {
		fetchCourts: async function (context): Promise<void> {
			const res = await api.get('/api/courts')
			const courts = res?.data

			context.commit('ADD_COURTS', courts)
		},
		fetchCourthouses: async function (context): Promise<void> {
			const res = await api.get('/api/courthouses')
			const courts = res?.data

			context.commit('ADD_COURTHOUSES', courts)
		},
	},
}
